import React from 'react';

export function RatingQuestion({ question, value, onChange }) {
  const currentValue = value || {};
  const minRating = question.minRating || 1;
  const maxRating = question.maxRating || 5;
  const ratingLabels = question.ratingLabels || {};
  const statements = question.statements || [];

  const handleRatingChange = (statementId, rating) => {
    onChange({
      ...currentValue,
      [statementId]: rating
    });
  };

  const getRatingButtons = (statementId) => {
    const buttons = [];
    for (let i = minRating; i <= maxRating; i++) {
      const isSelected = currentValue[statementId] === i;
      buttons.push(
        <button
          key={i}
          type="button"
          onClick={() => handleRatingChange(statementId, i)}
          className={`w-12 h-12 rounded-lg font-semibold transition-all ${
            isSelected
              ? 'bg-gradient-to-r from-amber-400 to-orange-500 text-white shadow-lg scale-110'
              : 'bg-gray-100 text-gray-700 hover:bg-amber-100 hover:text-amber-700 hover:scale-105'
          }`}
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  return (
    <div className="space-y-6">
      {/* Rating scale legend */}
      <div className="flex justify-between items-center px-2 text-sm text-gray-600 mb-4">
        {ratingLabels[minRating] && (
          <span className="text-left max-w-[40%]">{ratingLabels[minRating]}</span>
        )}
        {ratingLabels[maxRating] && (
          <span className="text-right max-w-[40%]">{ratingLabels[maxRating]}</span>
        )}
      </div>

      {/* Statements */}
      {statements.map((statement) => (
        <div
          key={statement.id}
          className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-amber-300 transition"
        >
          <p className="text-gray-800 font-medium mb-4">{statement.text}</p>

          <div className="flex justify-center gap-2">
            {getRatingButtons(statement.id)}
          </div>
        </div>
      ))}

      {/* Optional: Show rating scale labels */}
      {(ratingLabels[minRating] || ratingLabels[maxRating]) && (
        <div className="flex justify-between items-center px-2 text-xs text-gray-500 italic mt-2">
          <span>{minRating}</span>
          <span>{maxRating}</span>
        </div>
      )}
    </div>
  );
}
